import { isEmpty } from 'lodash';
import React from 'react';
import parse from 'html-react-parser';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
  DWTCVirtualAssetsApplicationWrapper,
  DWTCVirtualAssetsApplicationContainer,
  DWTCVirtualAssetsApplicationTitle,
  DWTCVirtualAssetsApplicationBody,
  DWTCVirtualAssetsApplicaitonTextWrapper,
  DWTCVirturalAssetsApplicationListWrapper,
  DWTCVirtualAssetsApplicationButtons,
  DWTCVirtualAssetsApplicationImage,
} from '../styles/DWTCVirtualAssetsApplications.styled';
import { Button } from '../styles/Button.styled';

export default function DWTCVirtualAssetsApplications({ data, dir }) {
  const { title, virtualDescription, links, virtualAssetsApplicationImage, contentTypeAlias } =
    data;
  return (
    <DWTCVirtualAssetsApplicationWrapper id={contentTypeAlias}>
      <DWTCVirtualAssetsApplicationContainer>
        <DWTCVirtualAssetsApplicationTitle dir={dir}>{title}</DWTCVirtualAssetsApplicationTitle>
        <DWTCVirtualAssetsApplicationBody>
          <DWTCVirtualAssetsApplicaitonTextWrapper>
            <div className="description">{parse(virtualDescription)}</div>
            <DWTCVirturalAssetsApplicationListWrapper>
              <DWTCVirtualAssetsApplicationButtons>
                {isEmpty(links) ||
                  links.map((linkItem, index) => (
                    <Button
                      target={index === 0 ? 'self' : 'blank'}
                      stylevariant={index === 0 ? 'red' : 'black'}
                      to={linkItem.url}
                      dir={dir}
                    >
                      {linkItem.name}
                    </Button>
                  ))}
              </DWTCVirtualAssetsApplicationButtons>
            </DWTCVirturalAssetsApplicationListWrapper>
          </DWTCVirtualAssetsApplicaitonTextWrapper>

          <DWTCVirtualAssetsApplicationImage>
            {isEmpty(virtualAssetsApplicationImage) || (
              <LazyLoadImage src={virtualAssetsApplicationImage.url} alt={title} />
            )}
          </DWTCVirtualAssetsApplicationImage>
        </DWTCVirtualAssetsApplicationBody>
      </DWTCVirtualAssetsApplicationContainer>
    </DWTCVirtualAssetsApplicationWrapper>
  );
}
